export default "__VITE_ASSET__DOnMewDy__"